import { render, staticRenderFns } from "./QuestionTitle.vue?vue&type=template&id=6a20deb3"
import script from "./QuestionTitle.vue?vue&type=script&lang=js"
export * from "./QuestionTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports